import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { couple, navLinks } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F4EFE6]/90 backdrop-blur-md py-4 shadow-[0_1px_0_rgba(33,30,26,0.08)]"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => scrollTo(e, "#top")}
          className={`font-serif-display text-2xl md:text-[26px] font-medium tracking-wide transition-colors duration-500 ${
            scrolled ? "text-[#211E1A]" : "text-[#F4EFE6]"
          }`}
        >
          {couple.initials}
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              className={`link-underline text-[12px] font-medium uppercase tracking-widest-2 transition-colors duration-500 ${
                scrolled ? "text-[#211E1A] hover:text-[#9E2B25]" : "text-[#F4EFE6] hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="#rsvp"
            onClick={(e) => scrollTo(e, "#rsvp")}
            className={`hidden sm:inline-flex items-center text-[12px] font-medium uppercase tracking-widest-2 border px-6 py-[10px] rounded-sm transition-all duration-500 ${
              scrolled
                ? "border-[#211E1A] text-[#211E1A] hover:bg-[#9E2B25] hover:border-[#9E2B25] hover:text-[#F4EFE6]"
                : "border-[#F4EFE6] text-[#F4EFE6] hover:bg-[#F4EFE6] hover:text-[#211E1A]"
            }`}
          >
            RSVP
          </a>
          <button
            aria-label="Menu"
            onClick={() => setOpen((o) => !o)}
            className={`lg:hidden transition-colors duration-500 ${scrolled ? "text-[#211E1A]" : "text-[#F4EFE6]"}`}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? "max-h-[420px] opacity-100" : "max-h-0 opacity-0"
        } bg-[#F4EFE6]`}
      >
        <nav className="flex flex-col px-8 py-4">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              className="py-3 text-[13px] font-medium uppercase tracking-widest-2 text-[#211E1A] border-b border-[#211E1A]/10"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#rsvp"
            onClick={(e) => scrollTo(e, "#rsvp")}
            className="py-3 text-[13px] font-medium uppercase tracking-widest-2 text-[#9E2B25]"
          >
            RSVP
          </a>
        </nav>
      </div>
    </header>
  );
}
